import Splide from '@splidejs/splide';

export class RememberTarifsSlider {
    constructor(viewRoot: HTMLElement) {
        const sliders = viewRoot.querySelectorAll<HTMLElement>('.sliderRememberTarifs');

        if (sliders.length === 0) {
            return;
        }
        sliders.forEach((slider) => {
            new Splide(slider as HTMLElement, {
                type: 'slide',
                speed: 500,
                gap: 20,
                fixedWidth: 230,
                width: 990,
                pagination: false,
                start: 0,
                perPage: 4,
                classes: {
                    arrows: 'controls tns-controls',
                    prev: 'splide__arrow--prev controls-prev prev',
                    next: 'splide__arrow--next controls-next next',
                },
                breakpoints: {
                    740: {
                        perPage: 1,
                        width: 230,
                    },
                    1023: {
                        perPage: 2,
                        width: 480,
                    },
                    1290: {
                        perPage: 3,
                        width: 730,
                    },
                },
            }).mount();
            slider.classList.remove('initialstate');
        });
    }
}
